export enum CoverageCreditIncentiveType {
  FIXED = "fixed",
  PERCENTAGE = "percentage",
}

export enum CoverageCreditIncentiveRewardType {
  STORE_CREDIT = "store_credit",
  DISCOUNT_CODE = "discount_code",
}

export interface CoverageCreditIncentive {
  enabled: boolean;
  type: CoverageCreditIncentiveType;
  fixedAmount: number;
  percentageSettings: {
    percentage: number;
    storeCreditAmountCap?: number | null;
  };
  minimumQualifyingPurchaseAmount: number;
  creditExpirationDays?: number | null;
  sendEmail: boolean;
  sendExpirationReminderEmail?: boolean;
  expirationReminderDaysBefore?: number | null;
  /** Missing means store credit. */
  rewardType?: CoverageCreditIncentiveRewardType;
  discountCodePrefix?: string;
}

export interface PriceBracket {
  value: number;
  pricePoint: number;
}

export interface CountryCoverageRule {
  countries: string[];
  noCoverage?: boolean | null;
}

export interface PricingRuleSet extends CountryCoverageRule {
  type: "fixed" | "percentage";
  priceBrackets: PriceBracket[];
}

export enum DynamicReturnTypes {
  ITEM_COUNT = "item-count",
  CART_VALUE = "cart-value",
}

export interface DynamicReturnsPricingItemCount {
  type: DynamicReturnTypes.ITEM_COUNT;
  pricePerAdditonalItem: number;
  maxPrice: number;
}

export interface DynamicReturnsPricingCartValue {
  type: DynamicReturnTypes.CART_VALUE;
  maxPrice: number;
  pricingRuleSet: PricingRuleSet;
}

export type DynamicReturnPricing =
  | DynamicReturnsPricingCartValue
  | DynamicReturnsPricingItemCount;

export enum PackageProtectionPricingStrategy {
  CART_VALUE = "cart-value",
  PRICE_PER_ITEM = "price-per-item",
}

export enum MerchantPaidPackageProtectionPlusFeeType {
  FLAT = "flat",
  PERCENTAGE = "percentage",
}

export interface PackageProtectionPricePerItemPricing {
  basePrice: number;
  pricePerAdditionalItem: number;
  maxPrice: number;
}

export type InternationalReturnPricing = (CountryCoverageRule & {
  multiplier: number;
})[];
